module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features",
    attrs: {
      "id": "feature"
    }
  }, [_c('h2', [_vm._v("强大的产品特性")]), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.featureData), function(feature) {
    return _c('div', {
      staticClass: "feature-item"
    }, [_c('div', {
      staticClass: "function-logo",
      class: feature.logo
    }), _c('div', {
      staticClass: "feature-header"
    }, [_vm._v(_vm._s(feature.header))]), _c('p', [_vm._v(_vm._s(feature.content))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5e5a1bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/features.vue
// module id = 55
// module chunks = 0